module.exports = {
	"description": "Menus display a list of [MenuItems](./menu-item). The items can have actions or be used for navigation.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "MnrlReactNode"
			},
			"required": false,
			"description": "[MenuDivider](./menu-divider), [MenuGroup](./menu-group), or [MenuItem](./menu-item)"
		},
		"data": {
			"flowType": {
				"name": "Array",
				"elements": [
					{
						"name": "signature",
						"type": "object",
						"raw": "{ items: Array<Item>, title?: MnrlReactNode }",
						"signature": {
							"properties": [
								{
									"key": "items",
									"value": {
										"name": "Array",
										"elements": [
											{
												"name": "signature",
												"type": "object",
												"raw": "{\n  iconEnd?: React$Element<*>,\n  iconStart?: React$Element<*>,\n  disabled?: boolean,\n  divider?: boolean,\n  onClick?: (event: Object) => void,\n  render?: (item: Object, props: Object, theme: Object) => React$Element<*>,\n  secondaryText?: MnrlReactNode,\n  text?: MnrlReactNode,\n  variant?: 'regular' | 'danger' | 'success' | 'warning'\n}",
												"signature": {
													"properties": [
														{
															"key": "iconEnd",
															"value": {
																"name": "React$Element",
																"elements": [
																	{
																		"name": "unknown"
																	}
																],
																"raw": "React$Element<*>",
																"required": false
															}
														},
														{
															"key": "iconStart",
															"value": {
																"name": "React$Element",
																"elements": [
																	{
																		"name": "unknown"
																	}
																],
																"raw": "React$Element<*>",
																"required": false
															}
														},
														{
															"key": "disabled",
															"value": {
																"name": "boolean",
																"required": false
															}
														},
														{
															"key": "divider",
															"value": {
																"name": "boolean",
																"required": false
															}
														},
														{
															"key": "onClick",
															"value": {
																"name": "signature",
																"type": "function",
																"raw": "(event: Object) => void",
																"signature": {
																	"arguments": [
																		{
																			"name": "event",
																			"type": {
																				"name": "Object"
																			}
																		}
																	],
																	"return": {
																		"name": "void"
																	}
																},
																"required": false
															}
														},
														{
															"key": "render",
															"value": {
																"name": "signature",
																"type": "function",
																"raw": "(item: Object, props: Object, theme: Object) => React$Element<*>",
																"signature": {
																	"arguments": [
																		{
																			"name": "item",
																			"type": {
																				"name": "Object"
																			}
																		},
																		{
																			"name": "props",
																			"type": {
																				"name": "Object"
																			}
																		},
																		{
																			"name": "theme",
																			"type": {
																				"name": "Object"
																			}
																		}
																	],
																	"return": {
																		"name": "React$Element",
																		"elements": [
																			{
																				"name": "unknown"
																			}
																		],
																		"raw": "React$Element<*>"
																	}
																},
																"required": false
															}
														},
														{
															"key": "secondaryText",
															"value": {
																"name": "MnrlReactNode",
																"required": false
															}
														},
														{
															"key": "text",
															"value": {
																"name": "MnrlReactNode",
																"required": false
															}
														},
														{
															"key": "variant",
															"value": {
																"name": "union",
																"raw": "'regular' | 'danger' | 'success' | 'warning'",
																"elements": [
																	{
																		"name": "literal",
																		"value": "'regular'"
																	},
																	{
																		"name": "literal",
																		"value": "'danger'"
																	},
																	{
																		"name": "literal",
																		"value": "'success'"
																	},
																	{
																		"name": "literal",
																		"value": "'warning'"
																	}
																],
																"required": false
															}
														}
													]
												}
											}
										],
										"raw": "Array<Item>",
										"required": true
									}
								},
								{
									"key": "title",
									"value": {
										"name": "MnrlReactNode",
										"required": false
									}
								}
							]
						}
					}
				],
				"raw": "Array<{ items: Array<Item>, title?: MnrlReactNode }>"
			},
			"required": false,
			"description": "Data used to contruct Menu. See [example](#data)"
		},
		"getItemProps": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(props: Object, scope: Object) => Object",
				"signature": {
					"arguments": [
						{
							"name": "props",
							"type": {
								"name": "Object"
							}
						},
						{
							"name": "scope",
							"type": {
								"name": "Object"
							}
						}
					],
					"return": {
						"name": "Object"
					}
				}
			},
			"required": false,
			"description": "@Private Function that returns props to be applied to each item"
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Menu/Menu.js
// module id = 1625
// module chunks = 0